import { useEffect } from "react";

/**
 * Bumps a grid fetch sequence ref when filters change so in-flight
 * responses (e.g. empty search) cannot apply after the user clears/changes filters.
 * Pair with the same filter deps used by useResetPageOnFilterChange (do not include pageNumber).
 */
export default function useInvalidateFetchOnFilterChange(fetchSeqRef, filterDeps) {
  useEffect(() => {
    fetchSeqRef.current += 1;
    // filterDeps is the intended trigger list; ref is stable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, filterDeps);
}
